export function normalizeImageSrc(src: string): string {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '';
  return src.startsWith(basePath) ? src.slice(basePath.length) : src;
}
